import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { SpendOverTimeQuery, SpendOverTimeRequest } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const spendOverTimeQuery = graphql(`
  query spendOverTime($request: SpendOverTimeRequest!) {
    spendOverTime(SpendOverTimeRequest: $request) {
      points {
        groupKey
        groupName
        period
        totalValue
        transactionCount
      }
    }
  }
`);

/** One time bucket of aggregated spend (optionally per group). */
export type SpendOverTimePoint = SpendOverTimeQuery["spendOverTime"]["points"][number];

/**
 * Spend aggregated into time buckets, optionally grouped by buyer/supplier.
 * `groupBy` + `topN` on the request drive the grouped chart series;
 * `groupBy: NONE` returns a single total series.
 */
export function useSpendOverTime(
  request: SpendOverTimeRequest,
  options?: UseQueryOptions<SpendOverTimeQuery, unknown, SpendOverTimeQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["spendOverTime", request],
    spendOverTimeQuery,
    [{ request }],
    options,
  );

  return { data: data?.spendOverTime, ...rest };
}
